import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Flex, TextField, View, useTheme, Heading, Button } from "@aws-amplify/ui-react";
import { useContx } from "../../AuthProvider";
import Header from "../tables/Header";
import Config from "../../config";
import FormActions from "./FormActions";
import Modal from "react-modal";
import QRsSteps from "./QRsSteps";
import { modalStyles } from "./data";
import { Margin, usePDF } from "react-to-pdf";

const ResetForm = () => {
    const { loading, resetPassword } = useContx();
    const { tokens } = useTheme();
    const { state } = useLocation();
    const navigate = useNavigate();

    const [email, setEmail] = useState(state?.email || "");
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [confirmUrl, setConfirmUrl] = useState<string>("");

    const { toPDF, targetRef } = usePDF({
        method: "save",
        filename: "usepdf-example.pdf",
        page: { margin: Margin.SMALL },
    });

    const onSubmit = async () => {
        if (email) {
            const response = await resetPassword({ email });
            if (response?.success) {
                setConfirmUrl(response.data.confirm_url);
                setIsOpen(true);
            } else {
                console.error("Password reset failed:", response?.error);
            }
        }
    };

    const isDisabledCheck = loading || !email;

    let mds = { ...modalStyles };

    if (window.innerWidth < 1100) {
        mds.content.width = "85vw";
    }

    return (
        <>
            <Modal
                ariaHideApp={false}
                contentLabel="Example Modal"
                style={mds}
                isOpen={isOpen}
                onRequestClose={() => {
                    setIsOpen(false);
                    navigate(Config.routes.users);
                }}
            >
                <Button
                    marginBottom={10}
                    style={{ marginLeft: "96%", marginTop: "0", marginBottom: "0%" }}
                    onClick={() => setIsOpen(false)}
                >
                    X
                </Button>
                <div ref={targetRef}>
                    <QRsSteps confirmUrl={confirmUrl} />
                </div>
                <Button
                    width={{ base: "50%", large: "50%" }}
                    style={{ marginTop: "5%", marginLeft: "25%" }}
                    onClick={() => toPDF()}
                >
                    Print
                </Button>
            </Modal>
            <Header title="Reset Password" />
            <Flex
                direction={{ base: "column", large: "row" }}
                alignItems="flex-start"
                gap={tokens.space.xl}
                minHeight="15vh"
            >
                <View
                    backgroundColor="var(--amplify-colors-white)"
                    borderRadius="6px"
                    width={{ base: "100%", large: "70%" }}
                    padding="1rem"
                    minHeight="15vh"
                >
                    <Flex direction="column" width="100%">
                        <Heading level={5}>Reset Password for:</Heading>
                        <TextField
                            label="Email"
                            type="email"
                            value={email}
                            isDisabled={true}
                            onChange={(e) => setEmail(e.target.value)}
                            isRequired={true}
                        />
                    </Flex>
                </View>
                <View
                    backgroundColor="var(--amplify-colors-white)"
                    borderRadius="6px"
                    width={{ base: "100%", large: "30%" }}
                    padding="1rem"
                    minHeight="15vh"
                >
                    <FormActions
                        text="Reset Password"
                        formOnSubmit={onSubmit}
                        isLoading={loading}
                        isDisabled={isDisabledCheck}
                    />
                </View>
            </Flex>
        </>
    );
};

export default ResetForm;